import React, { useState, useMemo, useEffect } from "react";
import { Drawer, Button, Row, Select, DatePicker, Space, Typography, Spin, Pagination, Col, Modal , Input, message} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './view-all-component.scss';
import { useTranslation } from "react-i18next";
import { useStore } from "../../../store/store";
import dayjs from "dayjs";
import { GetComplaints , MarkDisputeAsReopened} from "../../../service/helpAndSupport/helpAndSupportService";
import moment from "moment";
import NodataImgTrukker from "../../../assets/images/nodata-img.svg";
import NodataImgAdeed from "../../../assets/adeed/images/nodata-img.svg";
import reOpenImgTrukker from "../../../assets/reopen-img.png";
import reOpenImgAdeed from "../../../assets/adeed/reopen-img.png";
import FilterIcon from "../../../assets/images/filter-vertical-helpandsupport.svg";
import { isAdeed } from "../../../constants/brand";

// ADEED Freight shows its blue copies of these images (src/assets/adeed).
const NodataImg = isAdeed ? NodataImgAdeed : NodataImgTrukker;
const reOpenImg = isAdeed ? reOpenImgAdeed : reOpenImgTrukker;
const { RangePicker } = DatePicker;
const ViewAllComplaints = () => {
    const { t } = useTranslation();
    const { user } = useStore();
    const [status, setStatus] = useState([ ]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10)
    const [totalRecord, setTotalRecords] = useState(0);

    const [filterApply, setFilterApply] = useState(false);
    const [dateRange, setDateRange] = useState({
        moveDate: {
            fromDate: new Date('2025-04-01').toISOString().split('T')[0]

            , toDate: new Date().toISOString().split('T')[0]
        },
    });

    const [openFilterModel, setOpenFilterModel] = useState(false);

    const [isReopenModalOpen,setIsReopenModalOpen] = useState(false)

    const [viewComplaintsData, setViewComplaintsData] = useState([
    ]);

    const [loading, setLoading] = useState(false);
    const [isClicked, setClicked] = useState("Ongoing");
    const [complaint, setComplaintData] = useState("");
    const [Remarks, setRemarks] = useState("");
    const [reOpenIssueLoader,setReOpenIssueLoader] = useState(false)


    const { TextArea } = Input;
    useEffect(() => {


        fetchComplaints();

    }, [isClicked, filterApply, currentPage]);
    const payload = {
        type: isClicked,
        supplierId: user?.userId,
        complaintId: "",
        statuses: isClicked === 'Resolved' ? ['Resolved'] : status,
        fromRaisedDate: dateRange?.moveDate?.fromDate,
        toRaisedDate: dateRange?.moveDate?.toDate,
        pageSize: pageSize,
        pageNumber: currentPage
    };

    const fetchComplaints = () => {
        setLoading(true);

        GetComplaints(payload)
            .then((response) => {
                if (response?.status === 200) {
                    setLoading(false)
                    setViewComplaintsData(response?.data?.data);
                    setCurrentPage(response?.data?.pagination?.pageNumber);
                    setPageSize(response?.data?.pagination?.pageSize);
                    setTotalRecords(response?.data?.pagination?.totalRecords);
                    setOpenFilterModel(false)
                } else {
                    setLoading(false)
                    console.log('Unexpected response status:', response?.status);
                    setOpenFilterModel(false)
                }
            })
            .catch((err) => {
                setLoading(false)
                console.log('Failed to load complaints. Please try again later.', err);
                setOpenFilterModel(false)
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleStatusChange = value => setStatus(value);
    const handleChangePage = (page) => {
        setCurrentPage(page);
    };
    // Handle Date Range Change
    const handleDateChange = (dates, dateString) => {
        if (dateString?.length == 2 && dateString[0] && dateString[1]) {
            let localLiveLoadsFilter = { ...dateRange };
            localLiveLoadsFilter.moveDate = {
                fromDate: dateString[0],
                toDate: dateString[1],
            };
            setDateRange(localLiveLoadsFilter);
        } else {
            let localLiveLoadsFilter = { ...dateRange };
            localLiveLoadsFilter.moveDate = { fromDate: "", toDate: "" };
            setDateRange(localLiveLoadsFilter);
        }

    };

    const handleClearFilter = () => {
        setStatus([ ]);
        setDateRange({
            moveDate: {
                fromDate: moment('2025-04-01', 'YYYY-MM-DD'),
                toDate: moment(),
            },
        });
        setFilterApply(!filterApply);
        setOpenFilterModel(false)
    };

    const getMonthName = (date) => {
        const monthNames = [
            t("NEED_HELP_JAN"),
            t("NEED_HELP_FEB"),
            t("NEED_HELP_MAR"),
            t("NEED_HELP_APR"),
            t("NEED_HELP_MAY"),
            t("NEED_HELP_JUN"),
            t("NEED_HELP_JUL"),
            t("NEED_HELP_AUG"),
            t("NEED_HELP_SEP"),
            t("NEED_HELP_OCT"),
            t("NEED_HELP_NOV"),
            t("NEED_HELP_DEC"),
        ];


        return monthNames[date.getMonth()];
    };

    const sortedAndGroupedData = useMemo(() => {
        const sortedData = [...viewComplaintsData].sort((a, b) => {

            const dateA = new Date(a.raisedDate);
            const dateB = new Date(b.raisedDate);

            const monthA = dateA.getMonth();
            const monthB = dateB.getMonth();

            const yearA = dateA.getFullYear();
            const yearB = dateB.getFullYear();


            if (yearA !== yearB) {
                return yearB - yearA;
            }
            return monthB - monthA;
        });


        return sortedData.reduce((groups, complaint) => {
            const date = new Date(complaint.raisedDate);
            const monthName = getMonthName(date);
            const year = date.getFullYear();


            const key = `${monthName} ${year}`;

            if (!groups[key]) {
                groups[key] = [];
            }
            groups[key].push(complaint);
            return groups;
        }, {});
    }, [viewComplaintsData]);




       const handleReopenDispute = () => {
setReOpenIssueLoader(true);
        const payload={
 "complaintId": complaint?.complaintId, 
  "remarks": Remarks,
  "status": 'Reopen', 
  "reOpenedBy":complaint?.supplierId
        }

        MarkDisputeAsReopened(payload)
            .then((response) => {
                if (response?.status === 200) {
                    setCurrentPage(response?.data?.pagination?.pageNumber);
                    message.success(response?.data?.data)
                    setReOpenIssueLoader(false);
                    
                }
            })
            .catch((err) => {
                setReOpenIssueLoader(false)
            })
            .finally(() => {
                setReOpenIssueLoader(false);
                setIsReopenModalOpen(false)
            });
    };
    return (
        <div className="view-all-components-wrapper">
            <Row className="button-row">
                <Button
                    onClick={() => setClicked("Ongoing")}
                    className={isClicked === "Ongoing" ? "activebtn" : "inActivebtn"}
                >
                    {t("NEED_HELP_ONGOING")}
                </Button>
                <Button
                    onClick={() => setClicked("Resolved")}
                    className={isClicked === "Resolved" ? "activebtn" : "inActivebtn"}
                >
                    {t("NEED_HELP_RESOLVED")}
                </Button>
            </Row>
            <Row style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '8px' }}>
                <div className="filter-btn" onClick={() => setOpenFilterModel(true)}><img src={FilterIcon} />{t("NEED_HELP_INVOICE_FILTERS")}</div>
            </Row>
            {loading ? <Spin style={{ marginLeft: "50%", marginTop: "10%" }}></Spin> : <div>
                {viewComplaintsData.length > 0 ? <div className="card-row">
                    {Object.keys(sortedAndGroupedData).map((month) => (
                        <div key={month}>
                            <span className="months-year">{month} {sortedAndGroupedData[month][0].year}</span>
                            {sortedAndGroupedData[month].map((complaint) => (
                                <div
                                    key={complaint.id}
                                    className="complaints-card"
                                >
                                    <Row className="complainID">
                                        {t("NEED_HELP_COMPLAIN_ID")}: {complaint?.complaintId ? complaint?.complaintId : "NA"}
                                        <span className={
                                            complaint?.resolutionStatus === "Open"
                                                ? 'Open-complaint-class'
                                                : complaint?.resolutionStatus === "Resolved"
                                                    ? 'resolved-complaint-class'
                                                    : 'progress-complaint-class'
                                        }>{complaint.resolutionStatus}</span>
                                    </Row>
                                    <Row gutter={[16,16]} className="card-compaint-first-row">
                                        <Col span={8} >
                                        <span className="invoice-span">
                                            {!complaint?.orderNumber ? <span className="raised-on">
                                                {t("NEED_HELP_DONOT_FIND_ORDER")}
                                            </span> :
                                                <>
                                                    <span>  {t("NEED_HELP_ORDER_ID")}: {complaint?.orderNumber}</span>
                                                </>
                                            }
                                            <span className="raised-on">
                                                {t("NEED_HELP_RAISED_ON")}: {moment.utc(complaint?.raisedDate).format("DD/MM/YYYY")}
                                            </span>

                                            <div>
                                        {complaint?.reopenedData?.length > 0 &&
                                            `Reopened on : ${dayjs(
                                            complaint.reopenedData[complaint.reopenedData.length - 1]
                                                ?.reopenedDate
                                            ).format("DD/MM/YYYY")}`}
                                        </div>

                                        </span>
                                        </Col>
                                        {/* {JSON.stringify(complaint?.reopenedData[complaint.reopenedData.length-1]?.reopenedDate)} */}
                                        <Col  className="actionType "  span={6}><span>{`( ${complaint?.actionType || "Self"}) `}</span><br/>
                                        <div>
                                        {complaint?.resolvedDate &&
                                            `Resolved on : ${dayjs(
                                            complaint?.resolvedDate
                                            ).format("DD/MM/YYYY")}`}
                                        </div>
                                        </Col>

                                


                                    </Row>

                                    {isClicked === 'Resolved' && <Row className="complaint-description-row">
                                        <span className="complaint">
                                            {t("NEED_HELP_QUERY_RESOLUTION")}:
                                        </span>
                                        <span className="complaint-description">
                                            {complaint.resolution ? complaint.resolution : "NA"}
                                        </span>
                                    </Row>}
                                    <Row className="complaint-description-row">
                                        <span className="complaint">
                                            {t("NEED_HELP_CATEGORY")}:
                                        </span>
                                        <span className="complaint-description">
                                            {complaint?.category ? complaint?.category : "NA"}
                                        </span>
                                    </Row>
                                    <Row className="complaint-description-row">

                                        {!complaint?.orderNumber ? <div className="move-date-wrapper">
                                            <div className="move-date-div-wrapper">
                                                <div className="move-date-title">{t("NEED_HELP_DFO_MOVE_DATE")}:  <span className="move-date-value">{moment.utc(complaint?.moveDate).format("DD/MM/YYYY")}</span></div>
                                                <div className="move-date-title">{t("NEED_HELP_DFO_FROM_LOC")}: <span className="move-date-value">{complaint?.fromLocation ? complaint?.fromLocation : "NA"}</span></div>
                                            </div>
                                            <div className="move-date-div-wrapper">
                                                <div className="move-date-title">{t("NEED_HELP_DFO_TO_LOC")}: <span className="move-date-value">{complaint?.toLocation ? complaint?.toLocation : "NA"}</span></div>
                                                <div className="move-date-title">{t("NEED_HELP_DFO_NO_TRUCKS")}:  <span className="move-date-value">{complaint?.noOfTrucks}</span></div>
                                            </div>

                                        </div> :
                                            <>
                                                <span className="complaint">
                                                    {t("NEED_HELP_COMPLAIN_DESRIPTION")}:
                                                </span>
                                                <span className="complaint-description">
                                                    {complaint.remarks ? complaint.remarks : "NA"}
                                                </span></>
                                        }
                                    </Row><hr/>
                                    {isClicked === 'Resolved' && 
                                    <span>Issue not resolved ? <span onClick={()=>{setIsReopenModalOpen(true);setComplaintData({complaintId:complaint?.complaintId, status:complaint?.resolutionStatus,supplierId:complaint?.supplierId})}} style={{textDecoration:"underline", color: 'var(--attention, rgba(249, 158, 0, 1))'}}>Reopen</span></span> }

                                </div>
                            ))}

                        </div>
                    ))}
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Pagination
                            current={currentPage}   // The current page number
                            pageSize={pageSize}     // The number of items per page
                            onChange={handleChangePage}  // The function to call when the page is changed
                            total={totalRecord}     // The total number of items (for calculating total pages)
                        />
                    </div>
                </div> : <Row justify={'center'} style={{ height: '60vh' }}>
                    <img src={NodataImg} alt='no data' />
                </Row>}

            </div>
            }
            {openFilterModel && <Drawer
                title={
                    <Space style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography.Text>{t("NEED_HELP_INVOICE_FILTERS")}</Typography.Text>
                        <Button style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} type="link" onClick={handleClearFilter}>
                            {t("NEED_HELP_CLEAR_FILTER")}
                        </Button>

                    </Space>
                }

                onClose={() => setOpenFilterModel(false)}
                width={520}
                visible={openFilterModel}
            >
                {isClicked === 'Ongoing' && <div style={{ marginBottom: 16 }}>
                    <Typography.Text>{t("NEED_HELP_STATUS")}</Typography.Text>
                    <Select
                        mode="multiple"
                        style={{ width: '100%' }}
                        value={status}
                        onChange={handleStatusChange}
                        placeholder="Select Status"
                    >
                        <Select.Option value="InProgress">{t("NEED_HELP_IN_PROGRESS")}</Select.Option>
                        <Select.Option value="Open">{t("NEED_HELP_OPEN")}</Select.Option>
                        <Select.Option value="Resolved">{t("NEED_HELP_RESOLVED")}</Select.Option>
                        <Select.Option value="Reopen">{t("NEED_HELP_REOPEN")}</Select.Option>
                    </Select>
                </div>}

                <div style={{ marginBottom: 16 }}>
                    <Typography.Text>{t("NEED_HELP_DFO_MOVE_DATE")}</Typography.Text>
                    <RangePicker
                        value={[
                            dateRange.moveDate.fromDate
                                ? dayjs(dateRange.moveDate.fromDate)
                                : null,
                            dateRange.moveDate.toDate
                                ? dayjs(dateRange.moveDate.toDate)
                                : null,
                        ]} // Bind the state values to the RangePicker
                        // Update state on change
                        onChange={(date, dateString) =>
                            handleDateChange(date, dateString)
                        }
                    // format="YYYY-MM-DD"  // Set the date format
                    />
                </div>

                <div style={{ textAlign: 'center', height: '80vh', marginTop: '50px' }}>
                    <Button onClick={() => setOpenFilterModel(false)} style={{ marginRight: 8, width: '40%' }}>
                        {t("COMMON_CANCEL_BTN")}
                    </Button>
                    <Button type="primary" style={{ width: '40%' }} onClick={fetchComplaints} loading={loading}>
                        {t("COMMON_APPLY_BTN")}
                    </Button>
                </div>
            </Drawer>}


                 <Modal
                title="Reopen Issue? "
                open={isReopenModalOpen}
                onCancel={() => setIsReopenModalOpen(false)}
                footer={[
                <Button key="cancel" onClick={() => setIsReopenModalOpen(false)}>
                No 
                </Button>,
                <Button
                key="reopen"
                type="primary"
                onClick={handleReopenDispute}
                loading={reOpenIssueLoader}
                >
                Yes
                </Button>,
                ]}
                >
                <div>
                <img style={{ marginLeft:'37%'}} src={reOpenImg}></img>
                <p>
                How can we make this better. Please tell us in few words
                </p>

                <TextArea
                placeholder="Enter your remarks here..."
                // value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                rows={6}      // 👈 big textarea
                style={{
                width: "100%",
                resize: "none",
                }}
                maxLength={500}
                /> 
                 <br/> 
                </div>
                </Modal>
                </div>
                );
                };

export default ViewAllComplaints;
